import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { DataModel, MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { InternshipListGridModel, InternshipListListingModel } from 'common/models/page-models/Student Internship List/Internship Table Model/internship-list.model';
import { InternshipFilterModel } from 'common/models/page-models/Student Internship List/Intership Filter Form/internship-list-filter-data.model';
import { InternshipListGridDataService } from 'common/services/data-services/admin/Intership-List/intership-list-grid-data.service';
import { InternshipListGridMetaModel } from 'common/models/page-models/Student Internship List/Internship Table Model/internship-list-meta.model';
import { SmMetaModel } from 'common/models/utility-models/meta-model';
import { BatchListDataService } from 'common/services/data-services/custom-service/batch-service';
import { branchListDataService } from 'common/services/data-services/custom-service/branchList-service';
import { stateListDataService } from 'common/services/data-services/custom-service/stateList-service.service';
import { environment } from 'src/environments/environment';
import { API_URL } from 'common/constants/sm-constants';
import { zoneListDataService } from 'common/services/data-services/custom-service/zoneList-service';


@Injectable({
    providedIn: 'root'
})
export class InternshipListGridWidgetService extends GridWidgetService<InternshipFilterModel, InternshipListListingModel> {
    constructor(protected override ds: InternshipListGridDataService,
        protected systemService: SystemService,
        private batchListService: BatchListDataService,
        private branchListService: branchListDataService,
        private stateService: stateListDataService,
        private regionList: zoneListDataService,
        ) {
        super(ds);

        // console.log('Internship Called')
    }

    async getFilterOptions(filterMetaModel: any) {
        const urlList = [{ url: environment.apiUrl + API_URL.getBatchList, payload: '' }, 
                { url: environment.apiUrl + API_URL.branchList, payload: '' }, 
                { url: environment.apiUrl + API_URL.stateList, payload: '' },
                ];
        await this.ds.apiCallFromMultipleAPIforGrid(urlList).then((data) => {
            // console.log(data);
            
            filterMetaModel.properties.selectedBatch.options = data[0].details;
            filterMetaModel.properties.selectedBranch.options = data[1].details;
            filterMetaModel.properties.selectedState.options = data[2].details;
        })
    }

    getMetaModel(): MetaModel {
        const meta = new InternshipListGridMetaModel().getMetaModel();
        return meta;
    }

    override  prepareMetaModel(dataModel: DataModel, metaModel: SmMetaModel, routeData: WidgetModel): Promise<SmMetaModel> {
        return new Promise<SmMetaModel>((resolve, reject) => {

            
          resolve(metaModel);
        });
      }

    // override prepareMetaModel(dataModel: DataModel, metaModel: InternshipListGridMetaModel, routeData: WidgetModel): Promise<SmMetaModel> {
    //     return new Promise<InternshipListGridMetaModel>((resolve, reject) => {
    //         console.log(routeData);

    //         // metaModel.properties.extraHeaderActions.selectedValue = routeData.transferData.transferData.studentInternshipStatus;
    //         this.batchListService.postData('').then((data) =>{
    //             console.log(data, 'DATA-----');
                
    //             metaModel.filterMeta.properties.selectedBatch.options = data.details;
    //         });
    //         this.branchListService.postData('').then((data) =>{
    //             metaModel.filterMeta.properties.selectedBranch.options = data.details;
    //         });
    //         this.stateService.postData('').then((data) =>{
    //             metaModel.filterMeta.properties.selectedState.options = data.details;
    //         });
    //         this.regionList.postData('').then((data) =>{
    //             metaModel.filterMeta.properties.selectedRegion.options = data.details;
    //         });
    //         resolve(metaModel);
    //       });
    // }

    unAssignStudents(payload) {
        this.ds.postDataToCustomEndPoint(payload, null, environment.apiUrl + API_URL.deleteInternshipStudent).then((data) => {
            this.systemService.showSuccess(data['header'].msg)
        })
    }

    // override prepareMetaModel(dataModel: AssignmentReportsListingModel, metaModel: AssignmentReportsGridMetaModel, routeData: WidgetModel): Promise<AssignmentReportsGridMetaModel> {
    //     return new Promise<AssignmentReportsGridMetaModel>((resolve, reject) => {
            
    //         this.batchListService.postData('').then((data) =>{
    //             metaModel.filterMeta.properties.selectedBatch.options = data.detail;
    //         });
    //         this.branchListService.postData('').then((data) =>{
    //             metaModel.filterMeta.properties.selectedBranch.options = data.detail;
    //         });
    //         this.stateService.postData('').then((data) =>{
    //             metaModel.filterMeta.properties.selectedState.options = data.detail;
    //         });
    //         this.locationListService.postData('').then((data) =>{
    //             metaModel.filterMeta.properties.selectedLocation.options = data.detail;
    //         });
    //         this.typesListService.postData('').then((data) =>{
    //             metaModel.filterMeta.properties.selectedType.options = data.detail;
    //         });
          
    //         resolve(metaModel);
    //     });
    // }
}